import React from "react";
import "./BannerDriver.css";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

export const BannerDriver = () => {
  return (
    <div className="BannerDriverContainer">
      <div className="fadeContainer">
        <Typography className="driveUs" variant="h3" color="initial">
          CONDUCE <br /> CON NOSOTROS
        </Typography>
        <div className="driveBtnCont">
          <Button
            className="driveBtn"
            variant="contained"
          >
            <p className="textDriver"> Sé un conductor</p>
          </Button>
        </div>
      </div>
    </div>
  );
};
